'use client';

import { useContext } from 'react';
import { BreakpointsContext, type breakpointsResult } from '../shared/Utils/BreakpointsProvider';
function useBreakpoints() {
  const result = useContext(BreakpointsContext);
  return result;
}
export default useBreakpoints;